import { render, staticRenderFns } from "./CompanyDistrictPromotionDetail.vue?vue&type=template&id=39f284e2&"
import script from "./CompanyDistrictPromotionDetail.vue?vue&type=script&lang=ts&"
export * from "./CompanyDistrictPromotionDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports